"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _core = require("../../core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_2d2ir3ntg5() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Separator/Separator.tsx";
  var hash = "a3448927dc3a10af24cb8347ee1c9f62e5570c2d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Separator/Separator.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 48
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "1": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 16
        }
      },
      "2": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 32,
          column: 5
        }
      },
      "3": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 67,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 31
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 15
          },
          end: {
            line: 38,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 15
          },
          end: {
            line: 38,
            column: 20
          }
        }, {
          start: {
            line: 38,
            column: 24
          },
          end: {
            line: 38,
            column: 30
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 27
          },
          end: {
            line: 39,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 27
          },
          end: {
            line: 39,
            column: 36
          }
        }, {
          start: {
            line: 39,
            column: 40
          },
          end: {
            line: 39,
            column: 52
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 41,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 40
          },
          end: {
            line: 41,
            column: 63
          }
        }, {
          start: {
            line: 41,
            column: 66
          },
          end: {
            line: 41,
            column: 75
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 42
          },
          end: {
            line: 42,
            column: 67
          }
        }, {
          start: {
            line: 42,
            column: 70
          },
          end: {
            line: 42,
            column: 79
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 48,
            column: 9
          },
          end: {
            line: 65,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 9
          },
          end: {
            line: 48,
            column: 13
          }
        }, {
          start: {
            line: 49,
            column: 10
          },
          end: {
            line: 64,
            column: 17
          }
        }],
        line: 48
      },
      "5": {
        loc: {
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 51,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 51,
            column: 28
          }
        }, {
          start: {
            line: 51,
            column: 32
          },
          end: {
            line: 51,
            column: 44
          }
        }],
        line: 51
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a3448927dc3a10af24cb8347ee1c9f62e5570c2d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2d2ir3ntg5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2d2ir3ntg5();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Separator = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Separator, _React$PureComponent);
  function Separator() {
    _classCallCheck(this, Separator);
    return _callSuper(this, Separator, arguments);
  }
  _createClass(Separator, [{
    key: "render",
    value: function render() {
      cov_2d2ir3ntg5().f[0]++;
      var _ref = (cov_2d2ir3ntg5().s[1]++, this.props),
        lineColor = _ref.lineColor,
        marginVertical = _ref.marginVertical,
        marginHorizontal = _ref.marginHorizontal,
        text = _ref.text,
        textColor = _ref.textColor,
        thickness = _ref.thickness,
        width = _ref.width;
      var margins = (cov_2d2ir3ntg5().s[2]++, {
        large: '50px',
        medium: '30px',
        small: '20px',
        xSmall: '12px'
      });
      cov_2d2ir3ntg5().s[3]++;
      return /*#__PURE__*/_react["default"].createElement(_core.Box, {
        className: "od-separator-fragment",
        borderBottomWidth: "".concat(thickness, "px"),
        width: (cov_2d2ir3ntg5().b[0][0]++, width) || (cov_2d2ir3ntg5().b[0][1]++, '100%'),
        borderBottomColor: (cov_2d2ir3ntg5().b[1][0]++, lineColor) || (cov_2d2ir3ntg5().b[1][1]++, 'neutrals40'),
        borderBottomStyle: "solid",
        my: marginVertical !== 'none' ? (cov_2d2ir3ntg5().b[2][0]++, margins[marginVertical]) : (cov_2d2ir3ntg5().b[2][1]++, 'initial'),
        mx: marginHorizontal !== 'none' ? (cov_2d2ir3ntg5().b[3][0]++, margins[marginHorizontal]) : (cov_2d2ir3ntg5().b[3][1]++, 'initial'),
        textAlign: "center"
        // @ts-expect-error Custom lineHeight override
        ,
        lineHeight: 0,
        p: 0
      }, (cov_2d2ir3ntg5().b[4][0]++, text) && (cov_2d2ir3ntg5().b[4][1]++, /*#__PURE__*/_react["default"].createElement(_core.Text, {
        className: "od-separator-text",
        color: (cov_2d2ir3ntg5().b[5][0]++, textColor) || (cov_2d2ir3ntg5().b[5][1]++, 'neutrals90'),
        display: "inline",
        position: "relative",
        p: "0 15px",
        bgColor: "neutrals0",
        textTransform: "uppercase",
        textAlign: "center",
        fontSize: "s00",
        top: "".concat(thickness / 2 - 1, "px"),
        paddingTop: "".concat(thickness / 2, "px"),
        paddingBottom: "".concat(thickness / 2, "px")
      }, text)));
    }
  }]);
  return Separator;
}((_react["default"].PureComponent));
_defineProperty(Separator, "defaultProps", (cov_2d2ir3ntg5().s[0]++, {
  marginHorizontal: 'none',
  marginVertical: 'none',
  thickness: 1
}));